import styled from 'styled-components'

export const CardWrap = styled.div`
  box-shadow: 0 -0.43rem 125rem 0 rgba(126, 157, 184, 0.1);
  background-color: ${props => props.theme.colors.senary};
`
